import type {PathMap} from '../../utils/mapFields'

export const URL_PARAM_TO_PATH = {width: 'data.width', height: 'data.height'}
export const CUSTOM_STYLE_NAMESPACE = 'design'
export const STYLE_DATA_PATH = `${CUSTOM_STYLE_NAMESPACE}.default`
export const WPHOTO_CUSTOM_DESIGN_TYPE = 'WPhotoCustomDesign'

// we move partial data from data namespace to design namespace to support non-variantable data in style
export const ORIGINAL_PATH_TO_PACKED: PathMap = {
    'data.title': 'title',
    'data.name': 'name',
    'data.uri': 'src',
    'data.alt': 'alt',
    'props.displayMode': 'displayMode',
    'props.onClickBehavior': 'onClickBehavior',
    // we always use `default` because this is classic editor
    'data.focalPoint': `${STYLE_DATA_PATH}.focalPoint`,
    'data.crop.x': `${STYLE_DATA_PATH}.crop.x`,
    'data.crop.y': `${STYLE_DATA_PATH}.crop.y`,
    'data.crop.width': `${STYLE_DATA_PATH}.crop.width`,
    'data.crop.height': `${STYLE_DATA_PATH}.crop.height`,
    'data.crop.svgId': `${STYLE_DATA_PATH}.cropMask.svgId`,
    'data.crop.flip': `${STYLE_DATA_PATH}.cropMask.flip`,
    'data.crop.rotate': `${STYLE_DATA_PATH}.cropMask.rotate`
}
